// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ALL_ORGS_ID } from '../../../../types/group';
import { HeaderService } from '../../../header.service';

@Component({
    selector: 'app-endpoint-top-threats',
    templateUrl: './endpoint-top-threats.component.html',
    styleUrls: ['./endpoint-top-threats.component.scss'],
    standalone: false
})
export class EndpointTopThreatsComponent {
  timeInterval = '336h';
  selectedOrgId$: BehaviorSubject<string> = new BehaviorSubject<string>(ALL_ORGS_ID);

  constructor(private headerService: HeaderService) {
    this.selectedOrgId$ = this.headerService.orgSelectedChanged;
  }

}
